// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aq1L3","toggle":"styles_toggle__3s0ed","preview":"styles_preview__1NbZg"};